// import React, { useEffect, useMemo } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Link, useLocation } from "react-router-dom";
// import {
//   goToStep,
//   selectCurrentStep,
//   selectStepCompletion,
// } from "../stepperSlice";
// import { selectPDEInfo, selectPDEReviewStatus } from "../../user/userSlice";

// const Stepper = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();

//   const currentStep = useSelector(selectCurrentStep);
//   const stepCompletion = useSelector(selectStepCompletion);

//   // Pull appointmentType from your Procedure slice
//   const appointmentType = useSelector(
//     (state) => state.Procedure.appointmentType
//   );

//   // 2) Pull the current PDE's review statuses
//   const pdeInfo = useSelector(selectPDEInfo);
//   const pdeReviewStatus = useSelector(selectPDEReviewStatus);
//   const currentPDE_ID = pdeInfo?.pdeData?.[0]?.pdE_ID;
//   const matchingReviewStatuses = pdeReviewStatus.filter(
//     (s) => s.pdE_ID === currentPDE_ID
//   );
//   const reviewStatusText = matchingReviewStatuses
//     .map((s) => s.statusName?.toLowerCase())
//     .join(", ");

//   // 1) Master list of all steps
//   const allSteps = useMemo(
//     () => [
//       {
//         label: (
//           <>
//             Property
//             <br />
//             Details
//           </>
//         ),
//         link: "/property",
//       },
//       {
//         label: (
//           <>
//             Property
//             <br />
//             Evaluation
//           </>
//         ),
//         link: "/PropertyEvaluationPage",
//       },
//       {
//         label: (
//           <>
//             Party
//             <br />
//             Details
//           </>
//         ),
//         link: "/PartyDetails",
//       },
//       {
//         label: (
//           <>
//             Upload
//             <br />
//             Document
//           </>
//         ),
//         link: "/UploadDocument",
//       },
//       {
//         label: (
//           <>
//             Review &<br />
//             Approval
//           </>
//         ),
//         link: "/ReviewApproval",
//       },
//       {
//         label: (
//           <>
//             Online
//             <br />
//             Payment
//           </>
//         ),
//         link: "/OnlinePayment",
//       },
//       {
//         label: (
//           <>
//             Online
//             <br />
//             Appointment
//           </>
//         ),
//         link: "/OnlineAppointment",
//       },
//     ],
//     []
//   );

//   // 2) Hide logic per step
//   // const shouldHideStep = (step) => {
//   //   // A) If review is accepted, always hide Review & Approval
//   //   if (
//   //     step.link === "/ReviewApproval" &&
//   //     reviewStatusText.includes("accepted")
//   //   ) {
//   //     return true;
//   //   }
//   //   // B) New registration (no appointmentType): only show first two
//   //   if (!appointmentType) {
//   //     return !["/property", "/PropertyEvaluationPage"].includes(step.link);
//   //   }
//   //   // C) appointmentType "P": hide only Upload & Review
//   //   if (appointmentType === "P") {
//   //     return ["/UploadDocument", "/ReviewApproval"].includes(step.link);
//   //   }
//   //   // D) Otherwise show all
//   //   return false;
//   // };

//   const shouldHideStep = (step) => {
//     // a) If review is accepted -> hide Review & Approval
//     if (
//       step.link === "/ReviewApproval" &&
//       reviewStatusText.includes("accepted")
//     ) {
//       return true;
//     }

//     // b) New registration (no appointmentType): only first two
//     if (!appointmentType) {
//       return !["/property", "/PropertyEvaluationPage"].includes(step.link);
//     }

//     // c) appointmentType "P": hide Upload & Review
//     if (
//       appointmentType === "P" &&
//       ["/UploadDocument", "/ReviewApproval"].includes(step.link)
//     ) {
//       return true;
//     }

//     // d) If review is NOT accepted -> hide Payment & Appointment
//     if (
//       !reviewStatusText.includes("accepted") &&
//       appointmentType !== "P" &&
//       ["/OnlinePayment", "/OnlineAppointment"].includes(step.link)
//     ) {
//       return true;
//     }

//     // else show
//     return false;
//   };

//   // 3) Filter visible steps
//   const steps = allSteps.filter((step) => !shouldHideStep(step));

//   // 4) Keep currentStep in sync
//   useEffect(() => {
//     const idx = steps.findIndex((s) => s.link === location.pathname);
//     if (idx !== -1) {
//       dispatch(goToStep(idx + 1));
//     }
//   }, [location.pathname, dispatch, steps]);

//   return (
//     <div className="mt-4 space-y-16 mx-auto flex flex-col items-start">
//       {steps.map((step, idx) => {
//         const stepNumber = idx + 1;
//         const nextStep = steps[idx + 1];
//         const shouldDrawLine = !!nextStep;

//         return (
//           <div className="relative flex items-start text-sm" key={step.link}>
//             {/* Indicator */}
//             <Link to={step.link}>
//               <div
//                 className={`
//                   w-8 h-8 rounded-full flex items-center justify-center
//                   ${
//                     stepCompletion[stepNumber] || currentStep >= stepNumber
//                       ? "bg-blue-500 text-white"
//                       : "bg-gray-300 text-gray-500"
//                   }
//                 `}
//               >
//                 {stepCompletion[stepNumber] ? "✓" : stepNumber}
//               </div>
//             </Link>

//             {/* Connector */}
//             {shouldDrawLine && (
//               <div
//                 className={`
//                   absolute left-3.5 top-8 bottom-0 w-1 h-[5rem]
//                   ${stepCompletion[stepNumber] ? "bg-blue-500" : "bg-gray-300"}
//                 `}
//               />
//             )}

//             {/* Label */}
//             <div className="ml-4 hidden md:block">
//               <div
//                 className={`${
//                   currentStep >= stepNumber ? "text-blue-500" : "text-gray-500"
//                 } font-semibold`}
//               >
//                 <Link to={step.link}>{step.label}</Link>
//               </div>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default Stepper;

import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  goToStep,
  selectCurrentStep,
  selectStepCompletion,
} from "../stepperSlice";
import { selectPDEInfo, selectPDEReviewStatus } from "../../user/userSlice";

const Stepper = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const currentStep = useSelector(selectCurrentStep);
  const stepCompletion = useSelector(selectStepCompletion);

  // Pull appointmentType from your Procedure slice
  const appointmentType = useSelector(
    (state) => state.Procedure.appointmentType
  );

  // 2) Pull the current PDE's review statuses
  const pdeInfo = useSelector(selectPDEInfo);
  const pdeReviewStatus = useSelector(selectPDEReviewStatus);

  const currentPDE_ID = pdeInfo?.pdeData?.[0]?.pdE_ID;
  const matchingReviewStatuses = pdeReviewStatus.filter(
    (s) => s.pdE_ID === currentPDE_ID
  );
  const reviewStatusText = matchingReviewStatuses
    .map((s) => s.statusName?.toLowerCase())
    .join(",");

  // Disable the first five steps if review is accepted
  const isAccepted = reviewStatusText.includes("accepted");
  const disableWhenAccepted = [
    "/property",
    "/PropertyEvaluationPage",
    "/PartyDetails",
    "/UploadDocument",
    "/ReviewApproval",
  ];

  // 1) Master list of all steps
  const allSteps = useMemo(
    () => [
      {
        label: (
          <>
            Property
            <br />
            Details
          </>
        ),
        link: "/property",
      },
      {
        label: (
          <>
            Property
            <br />
            Evaluation
          </>
        ),
        link: "/PropertyEvaluationPage",
      },
      {
        label: (
          <>
            Party
            <br />
            Details
          </>
        ),
        link: "/PartyDetails",
      },
      {
        label: (
          <>
            Upload
            <br />
            Document
          </>
        ),
        link: "/UploadDocument",
      },
      {
        label: (
          <>
            Review &<br />
            Approval
          </>
        ),
        link: "/ReviewApproval",
      },
      {
        label: (
          <>
            Online
            <br />
            Payment
          </>
        ),
        link: "/OnlinePayment",
      },
      {
        label: (
          <>
            Online
            <br />
            Appointment
          </>
        ),
        link: "/OnlineAppointment",
      },
    ],
    []
  );

  // 2) Hide logic per step
  const shouldHideStep = (step) => {
    // a) If review is accepted -> hide Review & Approval
    if (
      step.link === "/ReviewApproval" &&
      reviewStatusText.includes("accepted")
    ) {
      return true;
    }

    // b) New registration (no appointmentType): only first two
    if (!appointmentType) {
      return !["/property", "/PropertyEvaluationPage"].includes(step.link);
    }

    // c) appointmentType "P": hide Upload & Review
    if (
      appointmentType === "P" &&
      ["/UploadDocument", "/ReviewApproval"].includes(step.link)
    ) {
      return true;
    }

    // d) If review is NOT accepted -> hide Payment & Appointment
    if (
      !reviewStatusText.includes("accepted") &&
      appointmentType !== "P" &&
      ["/OnlinePayment", "/OnlineAppointment"].includes(step.link)
    ) {
      return true;
    }

    // else show
    return false;
  };

  // 3) Filter visible steps
  const steps = allSteps.filter((step) => !shouldHideStep(step));

  // 4) Keep currentStep in sync
  useEffect(() => {
    const idx = steps.findIndex((s) => s.link === location.pathname);
    if (idx !== -1) {
      dispatch(goToStep(idx + 1));
    }
  }, [location.pathname, dispatch, steps]);

  return (
    <div className="mt-4 space-y-16 mx-auto flex flex-col items-start">
      {steps.map((step, idx) => {
        const stepNumber = idx + 1;
        const nextStep = steps[idx + 1];
        const shouldDrawLine = !!nextStep;
        const isStepDisabled =
          isAccepted && disableWhenAccepted.includes(step.link);

        return (
          <div className="relative flex items-start text-sm" key={step.link}>
            {/* Indicator */}
            {isStepDisabled ? (
              <div
                className={`
                  w-8 h-8 rounded-full flex items-center justify-center
                  ${
                    stepCompletion[stepNumber] || currentStep >= stepNumber
                      ? "bg-blue-500 text-white"
                      : "bg-gray-300 text-gray-500"
                  }
                  cursor-not-allowed
                `}
              >
                {stepCompletion[stepNumber] ? "✓" : stepNumber}
              </div>
            ) : (
              <Link to={step.link}>
                <div
                  className={`
                    w-8 h-8 rounded-full flex items-center justify-center
                    ${
                      stepCompletion[stepNumber] || currentStep >= stepNumber
                        ? "bg-blue-500 text-white"
                        : "bg-gray-300 text-gray-500"
                    }
                  `}
                >
                  {stepCompletion[stepNumber] ? "✓" : stepNumber}
                </div>
              </Link>
            )}

            {/* Connector */}
            {shouldDrawLine && (
              <div
                className={`
                  absolute left-3.5 top-8 bottom-0 w-1 h-[5rem]
                  ${stepCompletion[stepNumber] ? "bg-blue-500" : "bg-gray-300"}
                `}
              />
            )}

            {/* Label */}
            <div className="ml-4 hidden md:block">
              <div
                className={`
                  ${
                    currentStep >= stepNumber
                      ? "text-blue-500"
                      : "text-gray-500"
                  } font-semibold
                `}
              >
                {isStepDisabled ? (
                  <span className="cursor-not-allowed">{step.label}</span>
                ) : (
                  <Link to={step.link}>{step.label}</Link>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
